import { RouteType } from "../config";

import CompilancePage from "../../pages/Compilance/CompilancePage";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";

const grupoCompliance: RouteType = {
  path: "/compliance",
  show: true,
  element: <CompilancePage />,
  state: "COMPLIANCE",
  sidebarProps: {
    displayText: "Compliance",
    icon: <LibraryAddCheckIcon />,
  },
};

export default grupoCompliance;
